import { gql } from "@apollo/client";

export const BATCH_CANCEL_APPOINTMENTS = gql`
  mutation batchCancelAppointments($data: BatchCancelAppointmentRequestInput!) {
    batchCancelAppointments(appointmentData: $data) {
      results {
        appointmentId
        success
        error
        petName
      }
      success
      messages
      cancelledIds
      failedIds
    }
  }
`;
